// src/components/ScrollToTop.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll naar boven bij elke route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // 'auto' voor direct, 'smooth' voor animatie
    });
  }, [pathname]);

  return null; // Dit component rendert niets
};

export default ScrollToTop;